module.exports = __webpack_public_path__ + "media/application/images/2023/stills_1.1.6-68ba5f217cc0ede4a2bb443186661e09.png";